<template>
  <section id="app">
    <section class="topics-wrapper">
      <div class="container">
        <topics-areas></topics-areas>
      </div>
    </section>
    <section class="data-holder" id="view-data">
      <div class="container">
        <div class="row">
          <div class="sidebar col-md-3">
            <div class="inner">
              <sidebar></sidebar>
            </div>
          </div>
          <div class="content-data col-md-9 extended">
            <div class="inner data">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
  import Topics from './components/TopicsAreas';
  import Sidebar from './components/Sidebar';
  import Lists from './components/Lists';

  export default {
    name: 'app',
    components: {
      'topics-areas': Topics,
      Sidebar,
      Lists,
    },
  };
</script>

<style>
  .topics-wrapper {
    border-bottom: 1px solid #EBEBEB;
    padding: 50px 0;
    background-color: white;
  }

  .data-holder {
    background-color: #fbfbfb;
    overflow: hidden;
  }

  .data-holder .extended {
    background-color: white;
  }

  .data-holder .extended:before {
    background-color: white !important;
    z-index: 1;
  }

  .data-holder .extended .data {
    position: relative;
    z-index: 2;
  }

  .data-holder .content-data .inner,
  .data-holder .sidebar .inner {
    padding: 75px 0 0 0;
  }

  .datos-wrapper .elementor-column-wrap {
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// App.vue?7aaf2a75